import React from 'react';
import { Skeleton, Stack } from '@mui/material';

type TableSkeletonProps = {
  rows?: number;
  columns?: number;
  dense?: boolean;
  'aria-label'?: string;
};

export const TableSkeleton: React.FC<TableSkeletonProps> = ({
  rows = 6,
  columns = 5,
  dense,
  ...rest
}) => {
  const rowHeight = dense ? 24 : 32;
  return (
    <Stack spacing={0.75} role="status" {...rest} aria-busy="true">
      {/* Header row */}
      <Stack direction="row" spacing={1}>
        {[...Array(columns)].map((_, cIdx) => (
          <Skeleton key={cIdx} variant="rectangular" height={rowHeight + 4} sx={{ flex: 1, borderRadius: 0.5 }} />
        ))}
      </Stack>
      {/* Data rows */}
      {[...Array(rows)].map((_, rIdx) => (
        <Stack key={rIdx} direction="row" spacing={1}>
          {[...Array(columns)].map((__, cIdx) => (
            <Skeleton key={cIdx} variant="rectangular" height={rowHeight} sx={{ flex: 1, opacity: 1 - rIdx * 0.08 }} />
          ))}
        </Stack>
      ))}
    </Stack>
  );
};
